/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Kérj segítséged a csapatodtól vagy az adminisztrátorodtól.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Nincs egyetlen találat sem a keresésre',
};
